import React, { useState, useEffect } from "react";
import { BiArrowBack } from "react-icons/bi";

export default function DateRangePicker({ mode = "range", onChange }) {
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];
  const yesterdayStr = new Date(today.getTime() - 86400000).toISOString().split("T")[0];
  const beforeYesterdayStr = new Date(today.getTime() - 2 * 86400000).toISOString().split("T")[0];
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() - today.getDay() + 1);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  const weekStartStr = weekStart.toISOString().split("T")[0];
  const weekEndStr = weekEnd.toISOString().split("T")[0];
  const weekAgoStr = new Date(today.getTime() - 6 * 86400000).toISOString().split("T")[0];
  const monthAgoStr = new Date(today.getTime() - 29 * 86400000).toISOString().split("T")[0];

  const [preset, setPreset] = useState("today"); // ✅ по умолчанию "Сегодня"
  const [custom, setCustom] = useState({ from: todayStr, to: todayStr });
  const [tempRange, setTempRange] = useState({ from: todayStr, to: todayStr });
  const [isMobile, setIsMobile] = useState(false);
  const [customMode, setCustomMode] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 700);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ При первой загрузке вызываем onChange со значением "Сегодня"
  useEffect(() => {
    onChange && onChange({ from: todayStr, to: todayStr });
  }, []); // выполнится один раз при монтировании

  const handlePreset = (key) => {
    if (key === "custom") {
      setCustomMode(true);
      return;
    }
    setPreset(key);
    let range;
    switch (key) {
      case "today":
        range = { from: todayStr, to: todayStr };
        break;
      case "yesterday":
        range = { from: yesterdayStr, to: yesterdayStr };
        break;
      case "beforeyesterday":
        range = { from: beforeYesterdayStr, to: beforeYesterdayStr };
        break;
      case "thisweek":
        range = { from: weekStartStr, to: weekEndStr };
        break;
      case "7days":
        range = { from: weekAgoStr, to: todayStr };
        break;
      case "month":
        range = { from: monthAgoStr, to: todayStr };
        break;
      default:
        range = { from: todayStr, to: todayStr };
    }
    onChange && onChange(range);
  };

  const handleCustom = (field, value) => {
    const updated = { ...tempRange, [field]: value };
    setTempRange(updated);
  };

  const applyCustom = () => {
    setCustom(tempRange);
    onChange && onChange(tempRange);
  };

  const goBack = () => setCustomMode(false);

  const presets = [
    { key: "today", label: "Сегодня" },
    { key: "yesterday", label: "Вчера" },
    { key: "beforeyesterday", label: "Позавчера" },
    { key: "thisweek", label: "Эта неделя" },
    { key: "7days", label: "7 дней" },
    { key: "month", label: "Месяц" },
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "8px",
        background: "#fff",
        border: "1px solid #e0e3eb",
        borderRadius: "8px",
        padding: "6px 10px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        minHeight: "58px",
        fontFamily: "system-ui, sans-serif",
        width: "100%",
        boxSizing: "border-box",
        transition: "all 0.2s ease",
      }}
    >
      {!customMode ? (
        <>
          {presets.map((btn) => (
            <button
              key={btn.key}
              onClick={() => handlePreset(btn.key)}
              style={{
                flex: isMobile ? "1 1 calc(33% - 4px)" : "none",
                padding: isMobile ? "6px 6px" : "6px 12px",
                borderRadius: "6px",
                border: "1px solid #cbd3e1",
                background: preset === btn.key ? "#4a6cf7" : "#f9fafc",
                color: preset === btn.key ? "#fff" : "#1a1a2e",
                fontSize: isMobile ? "13px" : "14px",
                cursor: "pointer",
                fontWeight: 500,
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
            >
              {btn.label}
            </button>
          ))}

          {/*{mode === "range" && (*/}
            <button
              onClick={() => setCustomMode(true)}
              style={{
                flex: isMobile ? "1 1 calc(33% - 4px)" : "none",
                padding: isMobile ? "6px 6px" : "6px 12px",
                borderRadius: "6px",
                border: "1px solid #cbd3e1",
                background: "#fff",
                color: "#1a1a2e",
                fontSize: isMobile ? "13px" : "14px",
                cursor: "pointer",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              Свой
            </button>
          {/*)}*/}
        </>
      ) : (
        <>
          {/* Левая часть — стрелка назад */}
          <div
            onClick={goBack}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#4a6cf7",
              marginRight: "4px",
            }}
            title="Назад"
          >
            <BiArrowBack size={20} />
          </div>

          {/* Блок выбора диапазона + кнопка */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: isMobile ? "wrap" : "nowrap",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
                color: "#444",
              }}
            >
              От:
              <input
                type="date"
                value={tempRange.from}
                onChange={(e) => handleCustom("from", e.target.value)}
                style={{
                  padding: "6px 8px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "13px",
                  color: "#1a1a2e",
                }}
              />
            </label>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
                color: "#444",
              }}
            >
              До:
              <input
                type="date"
                value={tempRange.to}
                onChange={(e) => handleCustom("to", e.target.value)}
                style={{
                  padding: "6px 8px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "13px",
                  color: "#1a1a2e",
                }}
              />
            </label>

            <button
              onClick={applyCustom}
              style={{
                padding: "6px 14px",
                borderRadius: "6px",
                border: "none",
                background: "#4a6cf7",
                color: "#fff",
                cursor: "pointer",
                fontSize: "13px",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              Сформировать
            </button>
          </div>
        </>
      )}
    </div>
  );
}
